import React from "react";
import { useTranslation } from "react-i18next";
import { Eyebrow } from "../components/ui.jsx";

/**
 * Final success page after the deletion confirm step. The account is now
 * soft-deleted (locked + queued for purge). Re-states the 7-day grace
 * window and the fiscal-record retention for clarity.
 */
export default function AccountDeleteDone() {
  const { t } = useTranslation();
  return (
    <main>
      <section className="bg-wash">
        <div className="container" style={{ padding: "56px 24px 32px", maxWidth: 720 }}>
          <Eyebrow>TableTalk</Eyebrow>
          <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>{t("deleteAccountDone.title")}</h1>
        </div>
      </section>

      <section style={{ padding: "32px 0 96px" }}>
        <div className="container" style={{ maxWidth: 640 }}>
          <p style={{ fontSize: 17, color: "var(--ink-2)", lineHeight: 1.6, margin: 0 }}>
            {t("deleteAccountDone.body")}
          </p>
          <p style={{ marginTop: 24, fontSize: 15, color: "var(--ink-2)", lineHeight: 1.6 }}>
            {t("deleteAccountDone.contact")}
          </p>
        </div>
      </section>
    </main>
  );
}
